define('app/views/checkout_header_view',['app/setup', 'app/models/user', 'app/views/base_view'], function(takhfifan) {

  takhfifan.CheckoutHeaderView = takhfifan.BaseView.extend({

    initialize: function() {
      var _this = this,
        source = undefined,
        sources ={
          utm: this.urlParam('utm_source'),
          sem: this.urlParam('sem_campaignid'),
          ref: document.referrer
        };

      if(this.paramHasValue(sources.utm)){
        source = sources.utm;
      }else if(this.paramHasValue(sources.sem)){
        source = "google_adwords";
      }else if(sources.ref.match(/^https?:\/\/([^\/]+\.)?google\.com(\/|$)/i)){
        source = "google_organic";
      }

      if(this.paramHasValue(sources.sem)){
        this.setCookie({ name: 'source_params', value: encodeURIComponent(window.location.search), expires: 30 });
      }


      if(source){
        this.setCookie({ name: 'source', value: source, expires: 30 });
      }

      takhfifan.eventHub.on('formkey', function(formKey) {
        _this.model.set('formKey', formKey);
      }, this);
    },

    paramHasValue: function (src) {
      return !(_.isNull(src) || src === 0);
    }

  });

  var $checkoutHeader = $('.tkh-checkout-header');
  var user = new takhfifan.User();
  new takhfifan.CheckoutHeaderView({
    el: $checkoutHeader.first(),
    model: user
  });
});

